import React, { useState, useEffect } from 'react';
import { useContent } from '../../contexts/ContentContext';
import './FeaturedProgramsAdmin.css';

const COMPANY_FIELDS = [
  { key: 'name', label: 'Nom', placeholder: 'DentoXcellence', type: 'text' },
  { key: 'tagline', label: 'Slogan', placeholder: 'Centre de Formation Continue en Médecine Dentaire', type: 'text' },
  { key: 'description', label: 'Description', placeholder: 'Leader de la formation dentaire en Algérie', type: 'textarea' },
  { key: 'phone', label: 'Téléphone', placeholder: '+213 797 60 74 81', type: 'text' },
  { key: 'email', label: 'E-mail', placeholder: 'contact@dentoxcellence.com', type: 'text' },
  { key: 'address', label: 'Adresse', placeholder: 'Vieux Kouba, Algérie', type: 'text' },
  { key: 'founded', label: 'Année de fondation', placeholder: '2020', type: 'text' },
  { key: 'registrationNumber', label: "Numéro d'enregistrement", placeholder: '', type: 'text' },
  { key: 'taxNumber', label: 'Numéro fiscal', placeholder: '', type: 'text' },
];

const CompanyAdmin = ({ contentPath }) => {
  const { getContent, updateContent } = useContent();
  const [companyData, setCompanyData] = useState(null);

  useEffect(() => {
    setCompanyData(getContent(contentPath));
  }, [contentPath, getContent]);

  const handleUpdate = (field, value) => {
    updateContent(`${contentPath}.${field}`, value);
    setCompanyData(getContent(contentPath));
  };

  if (!companyData) {
    return (
      <div className="programs-admin-loading">
        <i className="fas fa-spinner fa-spin"></i>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="programs-admin company-admin">
      <div className="admin-section-header">
        <div className="section-info">
          <h2>
            <i className="fas fa-building"></i>
            Informations de l&apos;entreprise
          </h2>
          <p>Coordonnées et identité affichées sur le site</p>
        </div>
      </div>

      <div className="section-settings">
        <div className="form-grid">
          {COMPANY_FIELDS.map((field) => (
            <div
              key={field.key}
              className={`form-group ${field.type === 'textarea' ? 'full-width' : ''}`}
            >
              <label>{field.label}</label>
              {field.type === 'textarea' ? (
                <textarea
                  value={companyData[field.key] || ''}
                  onChange={(e) => handleUpdate(field.key, e.target.value)}
                  placeholder={field.placeholder}
                  rows={3}
                />
              ) : (
                <input
                  type="text"
                  value={companyData[field.key] || ''}
                  onChange={(e) => handleUpdate(field.key, e.target.value)}
                  placeholder={field.placeholder}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyAdmin;
